var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78433 3.12876C7.8784 2.95708 8.1219 2.95708 8.21597 3.12876L13.9689 13.6278C14.0603 13.7946 13.9412 13.9997 13.7531 13.9999H2.24722C2.05907 13.9997 1.94001 13.7946 2.0314 13.6278L7.78433 3.12876ZM8.00015 10.9999C7.50309 10.9999 7.09976 11.4032 7.09976 11.9002C7.09997 12.3971 7.50322 12.7997 8.00015 12.7997C8.4969 12.7994 8.89935 12.397 8.89956 11.9002C8.89956 11.4033 8.49703 11.0001 8.00015 10.9999ZM7.25015 6.99986V10.2997H8.75015V6.99986H7.25015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultWarningIcon);
export default __webpack_public_path__ + "static/media/vault-warning-icon.12297beb2fa0930fb9feb6e5a2e51431.svg";
export { ForwardRef as ReactComponent };